module.exports = __webpack_public_path__ + "static/media/tutors-1.549f929f.png";